import { atom } from 'jotai';

export const atomModalHelp = atom<boolean>(false);
